import { useEffect } from "react"
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import DMSHeader from "../DMSHeader/DMSHeader";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import UserImagesView from "./UserImagesView";

const UserFaceHeader = () => {
    const { t } = useTranslation();
    const { state } = useLocation();

    let edit = state?.edit;

    useEffect(() => {
        GridStack.init();
    }, []);

    const layoutData = [
        {
            x: 0,
            y: 0,
            width: 12,
            height: 1,
            id: 0,
            component: (
                <DMSHeader
                    title={t("Face Registration")}
                    showIconsForback={edit}
                />
            ),
            haveOverflowVisible: true,
        },
        {
            x: 0,
            y: 1,
            width: 12,
            height: 12,
            id: 1,
            component: <UserImagesView />,
        },
    ];

    return (
        <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
            <GridItem layoutData={layoutData} />
        </div>
    );
}

export default UserFaceHeader;